import { CHILD_PAGE_NAME } from './types'

export const setChildPageName = (status) => ({
  type: CHILD_PAGE_NAME,
  payload: status,
})
